import { css } from "styled-components";

export const AddOnTogglerCardCss = css`
    .addon-pack-card {
        .ant-card-body {
            padding: 10px 12px;

            .title-text {
                font-weight: 500;
            }

            .addon-icon,
            .storage-icon {
                margin-right: 12px;
                font-size: 1rem;
                color: rgba(0,0,0,60%);
            }
        }

        &.close { 
            transition: background 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);

            .addon-info-div {
                margin-right: 10px;
                font-weight: 500;
                color: rgba(0,0,0,60%);
            }

            /* Default hover (orange) */
            &:hover {
                background: #ffe7ba;
                border: 1px solid #ffd591;
            }
        }

        .pricing-div {
            display: flex;
            justify-content: center;
            font-size: 12px;
        }

        &.open {
            .pricing-div {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                font-size: 12px;
            }

            /* override styles of common component */
            .styled-slider-input-number {
                padding-top: 4px;

                .input-number { 
                    input {
                        font-size: 0.9rem;
                        font-weight: 500;
                    }
                }
            }
        }
    }


`;

export const RoundedBorderGhostCardCss = css`
    .rounded-border-ghost-card {
        /* in the style of stripe card input */
        margin: 12px 0;
        border: 1px solid transparent;
        border-radius: 4px;
        box-shadow: 0 1px 3px 0 #e6ebf1;
    }
`;
